import moment from 'moment';
import DataList from 'components/core/SuperTable/DataList/DataList';
import EmptyList from 'components/core/EmptyList/EmptyList';
import { createSearchParams, useLocation, useNavigate, useParams } from 'react-router-dom';
import { CONFIG } from 'shared/configs/config';
import { useEffect, useState } from 'react';
import { handlePropertiesDetailTabNavData } from 'constants/TabNavData';
import { helperApprove } from 'helpers/modules/helperInvoices';
import TopPaymentBar from 'components/core/TopPaymentBar/TopPaymentBar';
import { HeaderTabNavigation, SelectBox, ToolBar } from 'components/core';
import { serverSidePaginationActive, useServerSidePagination } from 'hooks/useServerSidePagination';
import { isPermitted, useGetUserQuery } from 'services/userApi';
import { useGetPayoutsQuery } from 'services/payoutsApi';
import { getURLParams, useDateRangeSorting } from 'hooks/useDateRangeSorting';

export const PropertyDetailsAllInvoicesContainer = () => {
  const [pageSizeOptions, paginationState, previousButtonClick, nextButtonClick, setPageSize]: any =
    useServerSidePagination();
  const { id } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const { data: user } = useGetUserQuery({});
  const [
    rangeSelector,
    defaultSortingText,
    itemSlectedState,
    showDropdown,
    handlerSortingDropDownClick,
    handlerSortingOption,
  ]: any = useDateRangeSorting();

  // Hide Pay Invoices Now button for specific property ID
  const shouldHidePayButton = id === 'dd189323-16db-4b6c-81d4-1888243a833b';

  const pid = '"' + id + '"';

  const intialQuery = {
    invoiced_at: {
      lessThan: moment()
        .add(1, 'day')
        .set({ hour: 0, minute: 0, second: 0, millisecond: 0 })
        .format(),
      greaterThan:
        rangeSelector > 0
          ? moment()
              .subtract(rangeSelector, 'day')
              .set({ hour: 0, minute: 0, second: 0, millisecond: 0 })
              .format()
          : undefined,
    },
    property_id: { equalTo: pid },
    status: { in: ['APPROVED', 'PAID', 'DENIED'] },
  } as any;

  const [finalQueryParam, setFinalQueryParam]: any = useState();

  const invoicesParams = {
    first: serverSidePaginationActive ? paginationState.pageSize : CONFIG.DATA_OVERALL_LIMIT,
    offset: serverSidePaginationActive ? paginationState.pageIndex * paginationState.pageSize : 0,
    orderBy: 'INVOICED_AT_DESC',
    filter: finalQueryParam ?? intialQuery,
  };

  const { data, isSuccess } = useGetPayoutsQuery(invoicesParams);
  const dataNodes = data?.payouts?.nodes ?? [];

  const getStatusArray = dataNodes?.map((item: any) => item.status);
  const setStatusArray = [...getStatusArray];

  const totalRecords: number = data?.payouts?.totalCount ?? 0;
  const totalPageCount = Math.ceil(totalRecords / paginationState.pageSize);

  const [detailTabNavData] = handlePropertiesDetailTabNavData(id);
  const [tableColumns, handleIconClick, getInvoiceAmount] = helperApprove('PROPERTIES_INVOICES');
  const [enableSelect, setEnableSelect] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [tlAmount, setTlAmount]: any = useState();
  const [selectedIds, setSelectedIds]: any = useState();

  const [columnList, setColumnList]: any = useState([]);
  const [toggleHiddenColumnChanged, setToggleHiddenColumnChanged] = useState(false);

  const [visibleColumns, setVisibleColumns] = useState([]);
  const [filteredRow, setFilteredRow] = useState([]);
  const [totalCount, setTotalCount]: any = useState(0);

  useEffect(() => {
    setColumnList(tableColumns);
  }, [data]);

  const hdColList = [
    ...columnList.filter((item: any) => item.isHidden).map((val: any) => val.accessor),
  ];

  useEffect(() => {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    getInvoiceAmount(selectedRows, setTlAmount, setSelectedIds);
  }, [selectedRows]);

  useEffect(() => {
    setFinalQueryParam(intialQuery);
  }, [defaultSortingText]);

  useEffect(() => {
    navigate(
      {
        pathname: location.pathname,
        search: `?${createSearchParams(getURLParams(defaultSortingText))}`,
      },
      { replace: true }
    );
  }, [defaultSortingText]);

  useEffect(() => {
    const count = data?.payouts?.totalCount ?? 0;
    setTotalCount(count);
  }, [data]);

  const onClickFilterApplyButton = (finalQuery: any) => {
    if (finalQuery !== false) {
      const arrangeQuery = { ...intialQuery, ...finalQuery };
      setFinalQueryParam(arrangeQuery);
    } else {
      setFinalQueryParam(intialQuery);
    }
  };

  const handlePaynowOption = () => {
    setEnableSelect(true);
    setSelectedIds(null);
    setSelectedRows([]);
  };

  return (
    <>
      {enableSelect && (
        <TopPaymentBar
          selectedRowsLength={selectedRows?.length}
          setEnableSelect={setEnableSelect}
          totalAmount={tlAmount}
          ids={selectedIds}
        />
      )}
      <HeaderTabNavigation
        tabNavData={detailTabNavData}
        isShowOptionEnabled={false}
        isShowMoreOptionDisabled={false}
        columns={columnList}
        handleIconClick={(item: any) => {
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          handleIconClick(
            item,
            columnList,
            setColumnList,
            setToggleHiddenColumnChanged,
            toggleHiddenColumnChanged
          );
        }}
        isAdditionalButtonVisibled={isPermitted(user, 'paynow-option') && !shouldHidePayButton}
        onButtonClick={handlePaynowOption}
        additionalButtonLabel={'Pay Invoices Now'}
        isAdditionalButtonDisabled={
          enableSelect || dataNodes.length === 0 || !setStatusArray.includes('APPROVED')
        }
        additionalWrapperClasses={'mb-4'}
        visibleColumns={visibleColumns}
        filteredRow={filteredRow}
        isDownloadCsvButtonEnabled={isSuccess && dataNodes && dataNodes.length !== 0}
      />

      <ToolBar
        columns={columnList}
        handleIconClick={(item: any) => {
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          handleIconClick(
            item,
            columnList,
            setColumnList,
            setToggleHiddenColumnChanged,
            toggleHiddenColumnChanged
          );
        }}
        visibleColumns={visibleColumns}
        isShowOptionEnabled={false}
        filteredRow={filteredRow}
        isDownloadCsvButtonEnabled={isSuccess && totalCount !== 0}
        isFilterButtonEnabled
        onClickFilterApplyButton={onClickFilterApplyButton}
        isDownloadCompleteData={true}
        queryParam={{
          first: CONFIG.DATA_OVERALL_LIMIT,
          offset: 0,
          orderBy: 'INVOICED_AT_DESC',
          filter: finalQueryParam ?? intialQuery,
        }}
      >
        <SelectBox
          itemClickHandler={handlerSortingOption}
          defaultSelectBoxText={defaultSortingText}
          itemSelected={itemSlectedState}
          dropDownState={showDropdown}
          dropDownClickHandler={handlerSortingDropDownClick}
        />
      </ToolBar>
      {isSuccess && (
        <div>
          {dataNodes && dataNodes.length > 0 ? (
            <DataList
              tableType="approve"
              subTabType="innerPropertiesEarnings"
              data={dataNodes}
              tableWrapperType="grid-height-medium"
              isPagination={true}
              editNetTerm={true}
              hiddenColumnList={hdColList}
              toggleHiddenColumnChanged={toggleHiddenColumnChanged}
              setSelectedRows={setSelectedRows}
              enableSelect={enableSelect}
              isServerSidePagination={serverSidePaginationActive}
              previousPageClick={previousButtonClick}
              nextPageClick={nextButtonClick}
              setPageSizeValue={setPageSize}
              options={pageSizeOptions}
              totalPageCount={totalPageCount}
              pageSizeVal={paginationState.pageSize}
              pageIndexVal={paginationState.pageIndex}
              setVisibleColumns={setVisibleColumns}
              setFilteredRow={setFilteredRow}
            />
          ) : (
            <EmptyList />
          )}
        </div>
      )}
    </>
  );
};
